module.exports = __webpack_public_path__ + "static/img/gongxi.efb6e8a4.png";